import * as React from "react";

const SvgComponent = ({ fill = "#000", stroke = "#636F7C", ...props }) => (
  <svg
    width={30}
    height={30}
    fill={props.color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={0.5} y={0.5} width={29} height={29} rx={5.5} stroke={stroke} />
    <path
      d="M11.957 10.26v9.891h.565v-7.025l7.348-3.149-7.914-3.391v3.674Zm1.13 7.126c.455-.04.928-.06 1.413-.06 3.59 0 6.5 1.138 6.5 2.543 0 1.404-2.91 2.543-6.5 2.543S8 21.273 8 19.87c0-.965 1.37-1.803 3.391-2.235v1.556c-.343.155-.565.401-.565.679 0 .468.633.847 1.413.847s1.413-.38 1.413-.847c0-.278-.222-.524-.565-.679v-1.805Zm3.674 2.765c.468 0 .848-.253.848-.565 0-.312-.38-.565-.848-.565-.468 0-.848.253-.848.565 0 .312.38.565.848.565Z"
      fill={fill}
      fillOpacity={1}
    />
  </svg>
);

export default SvgComponent;